import {
  ConsultaSeguimentoPergunta07ApontaPorEnum,
  ConsultaSeguimentoPergunta07Model,
  ConsultaSeguimentoPergunta07OlharParaEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-07/model-consultaSeguimentoPergunta07'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum, MChatPerguntaOpcaoEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta07Model {
  header: MchatRfAplicacaoQueryModel
  perguntas: MchatRfAplicacaoQueryModel[]
  apontaComDedo: MchatRfAplicacaoQueryModel | undefined
  apontaPor: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta07Model
}

export const convertAplicacaoPergunta07 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta07Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_07_01)
  const perguntas = aplicacoes.filter((aplicacao) => PERGUNTA_07_PERGUNTAS.includes(aplicacao.pergunta))
  const apontaComDedo = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_07_06)
  const apontaPor = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_07_07)

  if (header === undefined) return null

  return {
    header,
    perguntas,
    apontaComDedo,
    apontaPor,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_07_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_07_OLHAR_PARA: convertAplicacoesToOlharPara(perguntas),
      PERGUNTA_07_APONTA_COM_DEDO: booleanToSimNaoEnum(apontaComDedo?.stPassou),
      PERGUNTA_07_APONTA_POR: convertPerguntaOpcaoToApontaPor(apontaPor?.perguntaOpcao),
    },
  }
}

const convertAplicacoesToOlharPara = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta07OlharParaEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta07OlharParaEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_OLHAR_PARA }
  )

const convertPerguntaOpcaoToApontaPor = (
  perguntaOpcao: MChatPerguntaOpcaoEnum | null | undefined
): ConsultaSeguimentoPergunta07ApontaPorEnum | undefined => {
  if (perguntaOpcao == null) return undefined

  return PERGUNTA_OPCAO_TO_APONTA_POR[perguntaOpcao]
}

const PERGUNTA_07_PERGUNTAS = [
  MChatPerguntaEnum.PERGUNTA_07_02,
  MChatPerguntaEnum.PERGUNTA_07_03,
  MChatPerguntaEnum.PERGUNTA_07_04,
  MChatPerguntaEnum.PERGUNTA_07_05,
]

const EMPTY_OLHAR_PARA: Record<ConsultaSeguimentoPergunta07OlharParaEnum, undefined> = {
  [ConsultaSeguimentoPergunta07OlharParaEnum.AVIAO]: undefined,
  [ConsultaSeguimentoPergunta07OlharParaEnum.CAMINHAO]: undefined,
  [ConsultaSeguimentoPergunta07OlharParaEnum.BICHO]: undefined,
  [ConsultaSeguimentoPergunta07OlharParaEnum.ANIMAL]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta07OlharParaEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_07_02]: ConsultaSeguimentoPergunta07OlharParaEnum.AVIAO,
  [MChatPerguntaEnum.PERGUNTA_07_03]: ConsultaSeguimentoPergunta07OlharParaEnum.CAMINHAO,
  [MChatPerguntaEnum.PERGUNTA_07_04]: ConsultaSeguimentoPergunta07OlharParaEnum.BICHO,
  [MChatPerguntaEnum.PERGUNTA_07_05]: ConsultaSeguimentoPergunta07OlharParaEnum.ANIMAL,
}

const PERGUNTA_OPCAO_TO_APONTA_POR: Partial<Record<
  MChatPerguntaOpcaoEnum,
  ConsultaSeguimentoPergunta07ApontaPorEnum
>> = {
  [MChatPerguntaOpcaoEnum.AJUDA]: ConsultaSeguimentoPergunta07ApontaPorEnum.AJUDA,
  [MChatPerguntaOpcaoEnum.INTERESSE]: ConsultaSeguimentoPergunta07ApontaPorEnum.INTERESSE,
}
